import React from "react";
import {
  Box,
  VStack,
  HStack,
  Card,
  CardHeader,
  CardBody,
  Switch,
  Heading,
} from "@chakra-ui/react";
import CohortList from "./CohortList";
import CreateCohortForm from "./CreateCohortForm";
import { useInstitutionConfig } from "./InstitutionConfigContext";

export default function CohortManagementTab() {
  const {
    formData,
    config,
    institution,
    session,
    handleUpdateField,
  } = useInstitutionConfig();

  return (
    <Card bg="gray.800" borderColor="gray.600">
      <CardHeader>
        <HStack justifyContent="space-between">
          <Heading size="md" color="white">Cohort Management</Heading>
          <Switch
            isChecked={formData.cohortManagementEnabled || false}
            onChange={(e) => handleUpdateField("cohortManagementEnabled", e.target.checked)}
            colorScheme="blue"
          />
        </HStack>
      </CardHeader>
      <CardBody>
        <VStack spacing={6} align="stretch">
          {/* Cohort List Section - Always render to avoid hooks issues */}
          <Box display={formData.cohortManagementEnabled ? "block" : "none"}>
            <Heading size="sm" color="white" mb={4}>Existing Cohorts</Heading>
            <CohortList
              institution={institution}
              enabled={formData.cohortManagementEnabled}
              session={session}
              institutionConfig={config}
              onRefresh={(refreshFn) => {
                window.cohortRefresh = refreshFn;
              }}
            />
          </Box>

          {/* Create Cohort Form Section - Always render to avoid hooks issues */}
          <Box display={formData.cohortManagementEnabled ? "block" : "none"}>
            <Heading size="sm" color="white" mb={4}>Create New Cohort</Heading>
            <CreateCohortForm
              institution={institution}
              enabled={formData.cohortManagementEnabled}
              session={session}
              onCohortCreated={() => {
                if (window.cohortRefresh) {
                  window.cohortRefresh();
                }
              }}
            />
          </Box>
        </VStack>
      </CardBody>
    </Card>
  );
}
